import { render, staticRenderFns } from "./addCutBed.vue?vue&type=template&id=10a6334b&scoped=true"
import script from "./addCutBed.vue?vue&type=script&lang=js"
export * from "./addCutBed.vue?vue&type=script&lang=js"
import style0 from "./addCutBed.vue?vue&type=style&index=0&id=10a6334b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6334b",
  null
  
)

export default component.exports